// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__ZZPqW","spin":"Spinner_spin__2wGKJ","container":"Spinner_container__1exbF"};